import('./bootstrap/bootstrap').then(() => {
    import('./main');
});
